import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const TermsConditionsWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.filterCardBg};
  min-height: calc(100vh - 80px);
  padding: 24px 0 30px 0;
  ${mq(768)} {
    min-height: calc(100vh - 60px);
  }
`;

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.brandColor};
  text-transform: capitalize;
  font-size: ${({ theme }) => theme.fontsizes.body18};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  margin-bottom: 10px;
  margin-top: 10px;
`;

export const P = styled.p`
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font500};
  margin-bottom: 18px;
`;

export const Info = styled(P)`
  margin-bottom: 10px;
`;

export const Ul = styled.ul`
  padding: 0;
  margin-bottom: 18px;
  list-style: disc;
  padding-inline: 20px;
`;

export const Li = styled.li`
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  padding-left: 20px;
  position: relative;
  margin-bottom: 8px;
`;

export const Link = styled.a`
  font-size: 1.4rem;
  color: #000;
`;
